import ExternalNavigation, {
  ExternalNavigationStateProps,
  ExternalNavigationOwnProps,
} from 'components/features/external/ExternalNavigation/ExternalNavigation'
import { connect } from 'react-redux'
import { createSelector } from 'reselect'
import { currentUrlSelector } from 'selectors/globalSelectors'
import { withRouter } from 'react-router-dom'

const mapStateToProps = createSelector(
  currentUrlSelector,
  (currentUrl) => ({
    currentUrl,
  })
)

const ExternalNavigationContainer = withRouter(
  connect<ExternalNavigationStateProps, {}, ExternalNavigationOwnProps>(
    mapStateToProps,
  )(ExternalNavigation)
)

export default ExternalNavigationContainer
